import { MarketingLayout, Hero, Problem, Solution, TwoLayers, CtaBand } from "../marketing/Sections";

export default function Landing() {
  return (
    <MarketingLayout>
      <Hero />
      <Problem />
      <Solution />
      <TwoLayers />
      <CtaBand />
    </MarketingLayout>
  );
}
